import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

export default class BusinessGoalsGoalDescriptionController extends Controller {
  @tracked descriptionIsEditable = false;
  @tracked goalWizardIsOpen = false;

  @action
  setDelta(changeset, e) {
    changeset.set('description', e);
  }

  @action
  handleDescriptionSave(changeset) {
    changeset.save();
    this.toggleDescriptionIsEditable();
  }

  @action
  handleDescriptionCancel(changeset) {
    changeset.rollback();
    this.toggleDescriptionIsEditable();
  }

  @action
  toggleDescriptionIsEditable() {
    this.descriptionIsEditable = !this.descriptionIsEditable;
  }

  @action
  toggleGoalWizard() {
    this.goalWizardIsOpen = !this.goalWizardIsOpen;
  }

  get breadcrumbs() {
    const goal = this.model;
    let parent = goal.get('parent');
    const breadcrumbs = [goal];
    while (parent?.content) {
      breadcrumbs.unshift(parent);
      parent = parent.get('parent');
    }
    return breadcrumbs;
  }
}
